import { Link } from "@tanstack/react-router";
import { ArrowRight, Newspaper } from "lucide-react";
import { useCases } from "@/lib/cases";
import { useT } from "@/lib/i18n";

export function CasesSection() {
  const { tk } = useT();
  const cases = useCases();
  return (
    <section className="border-y border-gold/15">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <div className="text-center mb-14">
          <span className="text-xs tracking-[0.4em] uppercase text-gold">
            {tk("home.cases.kicker", "Casos en los medios")}
          </span>
          <h2 className="font-serif text-4xl md:text-5xl mt-4">
            {tk("home.cases.title.a", "Elegidos en causas de ")}
            <em className="not-italic gold-gradient">
              {tk("home.cases.title.b", "alta repercusión")}
            </em>
          </h2>
          <p className="mt-6 text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            {tk(
              "home.cases.subtitle",
              "Más de 20 procedimientos con cobertura en prensa nacional confían en RR Lex Juristas para su defensa. Una trayectoria que avala nuestra discreción, criterio y rigor técnico.",
            )}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {cases.slice(0, 2).map((c) => (
            <article
              key={c.slug}
              className="group rounded-2xl border border-gold/20 bg-card/30 p-8 hover:border-gold/60 transition-colors flex flex-col"
            >
              <div className="flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-gold/80">
                <Newspaper size={14} />
                <span>{c.area}</span>
                <span className="text-muted-foreground/60">· {c.year}</span>
              </div>
              <h3 className="font-serif text-2xl md:text-3xl mt-4 leading-snug group-hover:text-gold transition-colors">
                {c.headline}
              </h3>
              <div className="gold-divider my-5 max-w-[60px]" />
              <p className="text-sm text-muted-foreground leading-relaxed flex-1">{c.summary}</p>
              <div className="mt-6 flex flex-wrap gap-2">
                {c.mentions.slice(0, 4).map((m) => (
                  <span
                    key={m.url}
                    className="text-[10px] tracking-[0.25em] uppercase text-foreground/60 border border-gold/20 rounded-full px-3 py-1"
                  >
                    {m.outlet}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-3 rounded-full bg-gold text-primary-foreground px-7 py-3.5 text-xs tracking-[0.3em] uppercase hover:bg-[oklch(0.88_0.08_85)] transition-colors"
          >
            {tk("home.cases.cta", "Ver todos los casos")} <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
}
